import * as Types from "../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetBusinessUnitQueryVariables = Types.Exact<{
  id: Types.Scalars["Int"];
  booksSearch?: Types.Maybe<Types.Scalars["String"]>;
}>;

export type GetBusinessUnitQuery = { __typename?: "query_root" } & {
  business_units_by_pk?: Types.Maybe<
    { __typename?: "business_units" } & Pick<
      Types.Business_Units,
      "id" | "name" | "is_archived"
    > & {
        organisation: { __typename?: "organisations" } & Pick<
          Types.Organisations,
          "id" | "name"
        >;
        business_unit_bank_exposure_limits: Array<
          { __typename?: "business_unit_bank_exposure_limits" } & Pick<
            Types.Business_Unit_Bank_Exposure_Limits,
            "bank_id" | "business_unit_id" | "exposure_limit" | "id"
          >
        >;
        currency_books: Array<
          { __typename?: "currency_books" } & Pick<
            Types.Currency_Books,
            "id" | "name"
          > & {
              bank_accounts: Array<
                { __typename?: "bank_accounts" } & {
                  bank?: Types.Maybe<
                    { __typename?: "banks" } & Pick<
                      Types.Banks,
                      "id" | "name"
                    > & {
                        image?: Types.Maybe<
                          { __typename?: "uploads" } & Pick<
                            Types.Uploads,
                            "public_url"
                          >
                        >;
                      }
                  >;
                }
              >;
              bank_accounts_aggregate: {
                __typename?: "bank_accounts_aggregate";
              } & {
                aggregate?: Types.Maybe<
                  { __typename?: "bank_accounts_aggregate_fields" } & Pick<
                    Types.Bank_Accounts_Aggregate_Fields,
                    "count"
                  >
                >;
              };
            }
        >;
      }
  >;
};

export const GetBusinessUnitDocument = gql`
  query GetBusinessUnit($id: Int!, $booksSearch: String) {
    business_units_by_pk(id: $id) {
      id
      name
      is_archived
      organisation {
        id
        name
      }
      business_unit_bank_exposure_limits {
        bank_id
        business_unit_id
        exposure_limit
        id
      }
      currency_books(where: { name: { _ilike: $booksSearch } }) {
        id
        name
        bank_accounts {
          bank {
            id
            name
            image {
              public_url
            }
          }
        }
        bank_accounts_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  }
`;

export function useGetBusinessUnitQuery(
  options: Omit<Urql.UseQueryArgs<GetBusinessUnitQueryVariables>, "query"> = {}
) {
  return Urql.useQuery<GetBusinessUnitQuery>({
    query: GetBusinessUnitDocument,
    ...options,
  });
}
